<template>
  <div>
    <div class="row">
      <div class="col-12 col-lg-6 m-auto">
        <span class="h5 border-left-primary">
          <span class="font-weight-light ml-3">{{ t('preview.order.coupon.redeem') }}</span>
        </span>
      </div>
      <div class="col-12 col-lg-6 form-group m-auto customerCouponRedeemInput">
        <input type="text" name="coupon_code" class="form-control form-control-sm"
               v-model="couponCode"
               v-on:keyup="checkCoupon(couponCode)"
               v-on:keyup.enter="checkCoupon(couponCode)"
               :placeholder="t('preview.order.coupon.code')">
      </div>
      <div v-show="couponSuccess" class="col-12 mt-3">
        <div class="alert alert-sm alert-success text-center"
             id="js-coupon-code-text-success-msg">Το κουπόνι σας εξαργυρώθηκε</div>
      </div>
      <div v-show="couponError" class="col-12 mt-3">
        <div class="alert alert-sm alert-warning text-center"
             id="js-coupon-code-text-error-msg">Άκυρο κουπόνι</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CheckoutCoupon',
  props: ['couponCode'],
  watch: {
    coupon (val) {
      this.couponCode = val
    }
  },
  computed: {
    ...mapGetters(['previewOrderData']),
    couponError () {
      return this.coupon.length > 0 && this.previewOrderData.couponDiscount === 0
    },
    couponSuccess () {
      return this.coupon.length > 0 && this.previewOrderData.couponDiscount > 0
    },
    coupon () {
      return this.previewOrderData.couponCode
    }
  },
  methods: {
    ...mapActions(['checkCoupon'])
  }
}
</script>
